import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import {
  assessmentReportsViewColumns,
  mapAssessmentReportsViewQuery,
} from "./AssessmentReportsView.default";
import { getAssessmentReports } from "../../repository/data.repository";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";
import { createGridRequest } from "../../hooks/useGridRequest";

export interface AssessmentReportsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function AssessmentReportsView(props: AssessmentReportsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={assessmentReportsViewColumns}
      mapQuery={mapAssessmentReportsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getAssessmentReports, { retry: true })}
      pageSize={100}
      schema={{
        groups: [
          {
            controls: [
              { type: "textbox", name: "name", label: "Name" },
              {
                type: "textbox",
                name: "createdByUserUserName",
                label: "Created by",
              },
              { type: "rangetimepicker", name: "createdOn", label: "Created On" },
            ],
          },
        ],
      }}
      actions={(record) => [
        // One "Results" action for every report; the page routes by kind (Base → KPI explorer, Meta → evaluation).
        {
          key: "results",
          label: "Results",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("Reports", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Reports", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default AssessmentReportsView;
